// In dev we leave VITE_PLATFORM_URL empty so the Sanctum CSRF endpoint resolves
// against the current browser origin (Vite proxies /sanctum to the backend),
// keeping the cookie SameSite-compatible. Production sets it to the API origin.
const fallbackPlatformUrl = typeof window !== "undefined" ? window.location.origin : "";

export const config = {
    apiUrl: import.meta.env.VITE_SMART_MAIL_API_URL ?? "http://smart-mail.test/api/v1",
    platformUrl: import.meta.env.VITE_PLATFORM_URL || fallbackPlatformUrl,
};
